import React, { FC } from 'react'
import ConditionList from './ConditionList'
import ConditionDetail from './ConditionDetail'
import { ConditionBundle } from '../../../../types/FHIRTypes/Bundle'

type ConditionsProps = {
    conditionData: ConditionBundle;
    conditionDetailId: string | undefined;
    page: string | undefined;
    isFetching: boolean;
    handleChangePage: (page: number) => void
    totalPages: number;
    currentPage: number;
}


const Conditions: FC<ConditionsProps> = ({ conditionData, conditionDetailId, page, isFetching, handleChangePage, totalPages, currentPage }) => {
    return (
        <div>
            {
                conditionDetailId && page === 'Condition' ? (
                    <ConditionDetail
                        conditionDetailId={conditionDetailId}
                    />
                ) :
                    <ConditionList
                        conditionData={conditionData}
                        isFetching={isFetching}
                        handleChangePage={handleChangePage}
                        totalPages={totalPages}
                        currentPage={currentPage}
                    />
            }
        </div>
    )
}

export default Conditions